import React, { useState } from 'react';

const ArtemisEvolution = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [expandedVariations, setExpandedVariations] = useState({});
  const [selectedVariation, setSelectedVariation] = useState({
    software1: 'v3',
    functions: 'v3',
    software2: 'v2',
    software3: 'v4'
  });

  const toggleVariations = (id) => {
    setExpandedVariations(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  // Code variation component
  const CodeVariation = ({ version, score, description, isSelected, onClick }) => (
    <div 
      style={{
        padding: '10px 15px',
        margin: '5px 0',
        background: isSelected ? 'rgba(155, 89, 182, 0.3)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: '8px',
        border: isSelected ? '2px solid #9B59B6' : '1px solid rgba(255, 255, 255, 0.1)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
      onClick={onClick}
      onMouseEnter={e => {
        if (!isSelected) e.currentTarget.style.background = 'rgba(155, 89, 182, 0.1)';
      }}
      onMouseLeave={e => {
        if (!isSelected) e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
      }}
    >
      <div>
        <span style={{ fontWeight: '600', color: '#9B59B6' }}>{version}</span>
        <span style={{ marginLeft: '10px', fontSize: '14px', opacity: 0.8 }}>{description}</span>
      </div>
      <div style={{
        background: 'rgba(155, 89, 182, 0.2)',
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: '600',
        color: '#9B59B6'
      }}>
        {score}/100
      </div>
    </div>
  );

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F2027 0%, #203A43 50%, #2C5364 100%)',
      color: 'white',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
      padding: '40px 20px',
      fontSize: '16px'
    }}>
      <div style={{ maxWidth: '1600px', margin: '0 auto' }}>
        <h1 style={{ 
          margin: '0 0 15px 0', 
          fontSize: '42px',
          fontWeight: '700',
          background: 'linear-gradient(135deg, #9B59B6, #8E44AD)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Artemis Evolution: Practical Optimizations
        </h1>
        <p style={{ margin: '0 0 30px 0', fontSize: '20px', opacity: 0.8 }}>
          Real-world examples of how Artemis optimizes across software paradigms
        </p>
        
        {/* Tab Navigation */}
        <div style={{
          display: 'flex',
          gap: '20px',
          marginBottom: '40px',
          borderBottom: '2px solid rgba(255, 255, 255, 0.1)',
          paddingBottom: '0'
        }}>
          <button
            onClick={() => setActiveTab('overview')}
            style={{
              background: 'none',
              border: 'none',
              color: activeTab === 'overview' ? '#9B59B6' : 'rgba(255, 255, 255, 0.6)',
              fontSize: '18px',
              fontWeight: '600',
              padding: '12px 24px',
              cursor: 'pointer',
              borderBottom: activeTab === 'overview' ? '3px solid #9B59B6' : '3px solid transparent',
              marginBottom: '-2px',
              transition: 'all 0.3s ease'
            }}
          >
            Overview
          </button>
          <button
            onClick={() => setActiveTab('software1')}
            style={{
              background: 'none',
              border: 'none',
              color: activeTab === 'software1' ? '#3498DB' : 'rgba(255, 255, 255, 0.6)',
              fontSize: '18px',
              fontWeight: '600',
              padding: '12px 24px',
              cursor: 'pointer',
              borderBottom: activeTab === 'software1' ? '3px solid #3498DB' : '3px solid transparent',
              marginBottom: '-2px',
              transition: 'all 0.3s ease'
            }}
          >
            Data Structures
          </button>
          <button
            onClick={() => setActiveTab('functions')}
            style={{
              background: 'none',
              border: 'none',
              color: activeTab === 'functions' ? '#F39C12' : 'rgba(255, 255, 255, 0.6)',
              fontSize: '18px',
              fontWeight: '600',
              padding: '12px 24px',
              cursor: 'pointer',
              borderBottom: activeTab === 'functions' ? '3px solid #F39C12' : '3px solid transparent',
              marginBottom: '-2px',
              transition: 'all 0.3s ease'
            }}
          >
            Function Optimization
          </button>
          <button
            onClick={() => setActiveTab('software2')}
            style={{
              background: 'none',
              border: 'none',
              color: activeTab === 'software2' ? '#E74C3C' : 'rgba(255, 255, 255, 0.6)',
              fontSize: '18px',
              fontWeight: '600',
              padding: '12px 24px',
              cursor: 'pointer',
              borderBottom: activeTab === 'software2' ? '3px solid #E74C3C' : '3px solid transparent',
              marginBottom: '-2px',
              transition: 'all 0.3s ease'
            }}
          >
            Model Parameters
          </button>
          <button
            onClick={() => setActiveTab('software3')}
            style={{
              background: 'none',
              border: 'none',
              color: activeTab === 'software3' ? '#27AE60' : 'rgba(255, 255, 255, 0.6)',
              fontSize: '18px',
              fontWeight: '600',
              padding: '12px 24px',
              cursor: 'pointer',
              borderBottom: activeTab === 'software3' ? '3px solid #27AE60' : '3px solid transparent',
              marginBottom: '-2px',
              transition: 'all 0.3s ease'
            }}
          >
            Agentic Prompts
          </button>
          <button
            onClick={() => setActiveTab('sqlMigration')}
            style={{
              background: 'none',
              border: 'none',
              color: activeTab === 'sqlMigration' ? '#9B59B6' : 'rgba(255, 255, 255, 0.6)',
              fontSize: '18px',
              fontWeight: '600',
              padding: '12px 24px',
              cursor: 'pointer',
              borderBottom: activeTab === 'sqlMigration' ? '3px solid #9B59B6' : '3px solid transparent',
              marginBottom: '-2px',
              transition: 'all 0.3s ease'
            }}
          >
            SQL Migration
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'overview' && (
          <div>
            {/* Evolution Process */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '16px',
              padding: '40px',
              marginBottom: '40px',
              border: '1px solid rgba(255, 255, 255, 0.1)'
            }}>
              <h2 style={{ margin: '0 0 30px 0', fontSize: '28px' }}>
                The Artemis Optimization Process
              </h2>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '30px'
              }}>
                <div style={{
                  textAlign: 'center',
                  padding: '20px'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #3498DB, #2980B9)',
                    margin: '0 auto 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '36px'
                  }}>
                    1
                  </div>
                  <h3 style={{ margin: '0 0 10px 0', color: '#3498DB' }}>Analyze</h3>
                  <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>
                    Artemis scans the entire codebase to identify optimization opportunities
                  </p>
                </div>

                <div style={{
                  textAlign: 'center',
                  padding: '20px'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #E74C3C, #C0392B)',
                    margin: '0 auto 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '36px'
                  }}>
                    2
                  </div>
                  <h3 style={{ margin: '0 0 10px 0', color: '#E74C3C' }}>Generate</h3>
                  <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>
                    Multiple variations are created for each optimization point
                  </p>
                </div>

                <div style={{
                  textAlign: 'center',
                  padding: '20px'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #27AE60, #229954)',
                    margin: '0 auto 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '36px'
                  }}>
                    3
                  </div>
                  <h3 style={{ margin: '0 0 10px 0', color: '#27AE60' }}>Evaluate</h3>
                  <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>
                    Each variation is scored based on performance, readability, and correctness
                  </p>
                </div>

                <div style={{
                  textAlign: 'center',
                  padding: '20px'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #9B59B6, #8E44AD)',
                    margin: '0 auto 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '36px'
                  }}>
                    4
                  </div>
                  <h3 style={{ margin: '0 0 10px 0', color: '#9B59B6' }}>Optimize</h3>
                  <p style={{ margin: 0, fontSize: '14px', opacity: 0.8 }}>
                    The best combination across the entire codebase is selected
                  </p>
                </div>
              </div>
            </div>

            {/* Key Features */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
              gap: '30px'
            }}>
              <div style={{
                background: 'rgba(52, 152, 219, 0.1)',
                borderRadius: '16px',
                padding: '30px',
                border: '1px solid rgba(52, 152, 219, 0.3)'
              }}>
                <h3 style={{ margin: '0 0 20px 0', color: '#3498DB' }}>
                  🔍 Whole Repository Analysis
                </h3>
                <p style={{ margin: 0, lineHeight: '1.8' }}>
                  Unlike traditional tools that optimize file-by-file, Artemis analyzes the entire 
                  codebase to find the best global optimization strategy. It considers interactions 
                  between components and finds the optimal combination of changes.
                </p>
              </div>

              <div style={{
                background: 'rgba(231, 76, 60, 0.1)',
                borderRadius: '16px',
                padding: '30px',
                border: '1px solid rgba(231, 76, 60, 0.3)'
              }}>
                <h3 style={{ margin: '0 0 20px 0', color: '#E74C3C' }}>
                  🧬 Multiple Variations
                </h3>
                <p style={{ margin: 0, lineHeight: '1.8' }}>
                  For each optimization point, Artemis generates multiple variations. It then uses 
                  evolutionary algorithms to test different combinations and find the configuration 
                  that performs best across all metrics.
                </p>
              </div>

              <div style={{
                background: 'rgba(39, 174, 96, 0.1)',
                borderRadius: '16px',
                padding: '30px',
                border: '1px solid rgba(39, 174, 96, 0.3)'
              }}>
                <h3 style={{ margin: '0 0 20px 0', color: '#27AE60' }}>
                  📊 Intelligent Scoring
                </h3>
                <p style={{ margin: 0, lineHeight: '1.8' }}>
                  Each variation is scored on multiple dimensions: performance, memory usage, 
                  readability, maintainability, and correctness. The scoring adapts based on 
                  your project's priorities.
                </p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'software1' && (
          <div>
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '16px',
              padding: '40px',
              marginBottom: '30px'
            }}>
              <h2 style={{ margin: '0 0 10px 0', fontSize: '32px', color: '#3498DB' }}>
                Software 1.0: Data Structure Optimization
              </h2>
              <p style={{ margin: '0 0 30px 0', fontSize: '18px', opacity: 0.8 }}>
                Artemis analyzes your entire codebase to find the optimal data structures
              </p>

              {/* Example: Data Structure Optimization */}
              <div style={{
                background: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '12px',
                padding: '30px',
                marginBottom: '30px',
                overflow: 'hidden'
              }}>
                <h3 style={{ margin: '0 0 20px 0', color: '#3498DB' }}>
                  Example: Customer Order Processing System
                </h3>
                
                {/* Side by side comparison */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '30px',
                  marginBottom: '30px'
                }}>
                  {/* Before Section */}
                  <div>
                    <h4 style={{ color: '#E74C3C', marginBottom: '15px' }}>❌ Before Optimization:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '450px',
                      border: '1px solid rgba(231, 76, 60, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`class OrderProcessor:
    def __init__(self):
        # Using LinkedList for order queue
        self.pending_orders = `}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>LinkedList()</span>{`
        # Using LinkedList for processing history
        self.processed_orders = `}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>LinkedList()</span>{`
        # Using List for customer lookup
        self.customers = `}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>[]</span>{`
        `}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>
        # No index for history lookup</span>{`
        
    def add_order(self, order):
        # O(1) insertion but poor cache locality
        self.pending_orders.append(order)
        
    def process_next_order(self):
        # O(1) removal from front
        order = self.pending_orders.`}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>remove_first()</span>{`
        # `}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>O(n) customer lookup</span>{`
        customer = `}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>next(c for c in self.customers 
                         if c.id == order.customer_id)</span>{`
        # Process order...
        self.processed_orders.append(order)
        `}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>
        # No index update</span>{`
        
    def get_customer_history(self, customer_id):
        # `}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>O(n) search through entire history</span>{`
        return `}<span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>[o for o in self.processed_orders 
                if o.customer_id == customer_id]</span>{`

# Performance: 
# - 100 orders/sec with 1000 customers
# - 500ms avg response time`}</code>
                    </pre>
                  </div>

                  {/* After Section */}
                  <div>
                    <h4 style={{ color: '#27AE60', marginBottom: '15px' }}>✅ After Artemis Optimization:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '450px',
                      border: '2px solid rgba(39, 174, 96, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`class OrderProcessor:
    def __init__(self):
        # Using Deque for efficient queue operations
        self.pending_orders = `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>collections.deque()</span>{`
        # Using Vector for cache-friendly storage
        self.processed_orders = `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>Vector()</span>{`
        # Using HashMap for O(1) lookups
        self.customers = `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>{}</span>{`
        `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>
        # New: Index for customer order history
        self.customer_order_index = 
            defaultdict(list)</span>{`
        
    def add_order(self, order):
        # O(1) insertion with better cache locality
        self.pending_orders.append(order)
        
    def process_next_order(self):
        # O(1) removal from front
        order = self.pending_orders.`}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>popleft()</span>{`
        # `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>O(1) customer lookup</span>{`
        customer = `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>self.customers[order.customer_id]</span>{`
        # Process order...
        self.processed_orders.append(order)
        `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>
        # Update index for fast history retrieval
        self.customer_order_index[order.customer_id].append(order)</span>{`
        
    def get_customer_history(self, customer_id):
        # `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>O(1) indexed lookup instead of O(n) search</span>{`
        return `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>self.customer_order_index[customer_id]</span>{`

# Performance: 
# - 940 orders/sec with 1000 customers (9.4x faster!)
# - 53ms avg response time`}</code>
                    </pre>
                  </div>
                </div>

                {/* Variations Section */}
                <div 
                  style={{
                    marginBottom: '20px',
                    padding: '20px',
                    background: 'rgba(155, 89, 182, 0.1)',
                    borderRadius: '8px',
                    border: '1px solid rgba(155, 89, 182, 0.3)',
                    cursor: 'pointer'
                  }}
                  onClick={() => toggleVariations('software1')}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 style={{ margin: 0, color: '#9B59B6' }}>
                      🧬 Artemis Generated Variations (4)
                    </h4>
                    <span style={{ fontSize: '14px', opacity: 0.7 }}>
                      {expandedVariations.software1 ? '▼' : '▶'} Click to {expandedVariations.software1 ? 'hide' : 'show'}
                    </span>
                  </div>
                  
                  {expandedVariations.software1 && (
                    <div style={{ marginTop: '20px' }}>
                      <p style={{ fontSize: '14px', marginBottom: '15px', opacity: 0.8 }}>
                        Artemis tests these variations across your entire codebase:
                      </p>
                      <CodeVariation 
                        version="Variation 1"
                        score={72}
                        description="ArrayList + ArrayList + List"
                        isSelected={selectedVariation.software1 === 'v1'}
                        onClick={() => setSelectedVariation({...selectedVariation, software1: 'v1'})}
                      />
                      <CodeVariation 
                        version="Variation 2"
                        score={85}
                        description="Deque + Vector + HashMap"
                        isSelected={selectedVariation.software1 === 'v2'}
                        onClick={() => setSelectedVariation({...selectedVariation, software1: 'v2'})}
                      />
                      <CodeVariation 
                        version="Variation 3"
                        score={94}
                        description="Deque + Vector + HashMap + Index"
                        isSelected={selectedVariation.software1 === 'v3'}
                        onClick={() => setSelectedVariation({...selectedVariation, software1: 'v3'})}
                      />
                      <CodeVariation 
                        version="Variation 4"
                        score={78}
                        description="PriorityQueue + TreeSet + B-Tree"
                        isSelected={selectedVariation.software1 === 'v4'}
                        onClick={() => setSelectedVariation({...selectedVariation, software1: 'v4'})}
                      />
                    </div>
                  )}
                </div>

                {/* After Section */}
                <div>
                  <h4 style={{ color: '#27AE60', marginBottom: '15px' }}>✅ After Artemis Optimization:</h4>
                  <pre style={{
                    background: 'rgba(0, 0, 0, 0.5)',
                    padding: '20px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    overflow: 'auto',
                    border: '2px solid rgba(39, 174, 96, 0.3)'
                  }}>
                    <code style={{ color: '#f8f8f2' }}>{`class OrderProcessor:
    def __init__(self):
        # Using Deque for efficient queue operations
        self.pending_orders = `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>collections.deque()</span>{`
        # Using Vector for cache-friendly storage
        self.processed_orders = `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>Vector()</span>{`
        # Using HashMap for O(1) lookups
        self.customers = `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>{}</span>{`
        # New: Index for customer order history
        self.customer_order_index = `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>defaultdict(list)</span>{`
        
    def add_order(self, order):
        # O(1) insertion with better cache locality
        self.pending_orders.append(order)
        
    def process_next_order(self):
        # O(1) removal from front
        order = self.pending_orders.popleft()
        # O(1) customer lookup
        customer = self.customers[order.customer_id]
        # Process order...
        self.processed_orders.append(order)
        # Update index for fast history retrieval
        self.customer_order_index[order.customer_id].append(order)
        
    def get_customer_history(self, customer_id):
        # O(1) indexed lookup instead of O(n) search
        return self.customer_order_index[customer_id]`}</code>
                  </pre>
                  <div style={{
                    marginTop: '15px',
                    padding: '15px',
                    background: 'rgba(39, 174, 96, 0.1)',
                    borderRadius: '8px',
                    border: '1px solid rgba(39, 174, 96, 0.3)'
                  }}>
                    <strong>Performance Improvements:</strong>
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                      gap: '15px',
                      marginTop: '10px'
                    }}>
                      <div>
                        <strong style={{ color: '#27AE60' }}>Speed:</strong>
                        <div>Customer lookup: O(n) → O(1)</div>
                        <div>History search: O(n) → O(1)</div>
                      </div>
                      <div>
                        <strong style={{ color: '#27AE60' }}>Memory:</strong>
                        <div>30% less memory usage</div>
                        <div>Better cache locality</div>
                      </div>
                      <div>
                        <strong style={{ color: '#27AE60' }}>Scalability:</strong>
                        <div>Handles 10x more orders</div>
                        <div>Consistent performance</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Repository-wide Impact */}
              <div style={{
                background: 'rgba(155, 89, 182, 0.1)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid rgba(155, 89, 182, 0.3)'
              }}>
                <h4 style={{ margin: '0 0 10px 0', color: '#9B59B6' }}>
                  🌐 Repository-wide Optimization
                </h4>
                <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.8' }}>
                  Artemis found <strong>47 similar patterns</strong> across the codebase and optimized them all:
                  <br/>• 12 LinkedList → Deque conversions
                  <br/>• 18 List lookups → HashMap conversions  
                  <br/>• 17 new indexes added for frequent searches
                  <br/>• Total performance improvement: <strong>3.7x faster</strong>
                </p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'functions' && (
          <div>
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '16px',
              padding: '40px',
              marginBottom: '30px'
            }}>
              <h2 style={{ margin: '0 0 10px 0', fontSize: '32px', color: '#F39C12' }}>
                Software 1.0: Function Optimization
              </h2>
              <p style={{ margin: '0 0 30px 0', fontSize: '18px', opacity: 0.8 }}>
                Artemis gets suggestions from LLMs and agents to optimize your functions
              </p>

              {/* Example: Image Processing Functions */}
              <div style={{
                background: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '12px',
                padding: '30px',
                marginBottom: '30px'
              }}>
                <h3 style={{ margin: '0 0 20px 0', color: '#F39C12' }}>
                  Example: Image Processing Pipeline
                </h3>
                
                {/* Side by side comparison */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '30px',
                  marginBottom: '30px'
                }}>
                  {/* Before Section */}
                  <div>
                    <h4 style={{ color: '#E74C3C', marginBottom: '15px' }}>❌ Original Functions:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '450px',
                      border: '1px solid rgba(231, 76, 60, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`def process_image_batch(images):
    """Process multiple images sequentially"""
    results = []
    for img in images:
        # Load image every time
        pil_img = Image.open(img)
        np_img = np.array(pil_img)
        
        # Apply filters one by one
        blurred = apply_blur(np_img)
        sharpened = apply_sharpen(blurred)
        enhanced = enhance_contrast(sharpened)
        
        # Save intermediate results
        save_temp_file(enhanced)
        results.append(enhanced)
    
    return results

def apply_blur(img):
    """Simple blur implementation"""
    kernel = np.ones((5,5)) / 25
    result = np.zeros_like(img)
    
    # Naive convolution
    for i in range(2, img.shape[0]-2):
        for j in range(2, img.shape[1]-2):
            for c in range(img.shape[2]):
                result[i,j,c] = np.sum(
                    img[i-2:i+3, j-2:j+3, c] * kernel
                )
    return result

# Performance: 8.5s for 10 images (1024x768)`}</code>
                    </pre>
                  </div>

                  {/* After Section */}
                  <div>
                    <h4 style={{ color: '#27AE60', marginBottom: '15px' }}>✅ Artemis Optimized:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '450px',
                      border: '2px solid rgba(39, 174, 96, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`def process_image_batch(images):
    """Optimized batch processing with parallelization"""
    # Pre-allocate memory
    results = [None] * len(images)
    
    # Use multiprocessing for parallel execution
    with mp.Pool(processes=mp.cpu_count()) as pool:
        # Process in chunks for better memory usage
        chunk_size = max(1, len(images) // mp.cpu_count())
        
        # Async processing with callback
        jobs = []
        for i, img_chunk in enumerate(chunks(images, chunk_size)):
            job = pool.apply_async(
                process_chunk_vectorized,
                (img_chunk,),
                callback=lambda r, idx=i: 
                    results.__setitem__(slice(idx*chunk_size, 
                    (idx+1)*chunk_size), r)
            )
            jobs.append(job)
        
        # Wait for completion
        for job in jobs:
            job.wait()
    
    return [r for r in results if r is not None]

def apply_blur(img):
    """Vectorized blur using scipy"""
    # Use optimized scipy implementation
    return scipy.ndimage.gaussian_filter(
        img, sigma=1.5, mode='reflect'
    )

# Performance: 0.9s for 10 images (1024x768)
# 9.4x faster!`}</code>
                    </pre>
                  </div>
                </div>

                {/* Key optimizations */}
                <div style={{
                  background: 'rgba(243, 156, 18, 0.1)',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid rgba(243, 156, 18, 0.3)',
                  marginBottom: '20px'
                }}>
                  <h4 style={{ margin: '0 0 15px 0', color: '#F39C12' }}>
                    🔍 Key Optimizations Applied:
                  </h4>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '15px'
                  }}>
                    <div>
                      <strong>Parallelization:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Multi-core processing</li>
                        <li>Async execution</li>
                        <li>Chunk-based processing</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Vectorization:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>NumPy operations</li>
                        <li>SciPy optimized filters</li>
                        <li>Eliminated nested loops</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Memory Efficiency:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Pre-allocation</li>
                        <li>In-place operations</li>
                        <li>Reduced temp files</li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Variations Section */}
                <div 
                  style={{
                    marginBottom: '20px',
                    padding: '20px',
                    background: 'rgba(155, 89, 182, 0.1)',
                    borderRadius: '8px',
                    border: '1px solid rgba(155, 89, 182, 0.3)',
                    cursor: 'pointer'
                  }}
                  onClick={() => toggleVariations('functions')}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 style={{ margin: 0, color: '#9B59B6' }}>
                      🧬 Artemis Function Variations (4)
                    </h4>
                    <span style={{ fontSize: '14px', opacity: 0.7 }}>
                      {expandedVariations.functions ? '▼' : '▶'} Click to {expandedVariations.functions ? 'hide' : 'show'}
                    </span>
                  </div>
                  
                  {expandedVariations.functions && (
                    <div style={{ marginTop: '20px' }}>
                      <p style={{ fontSize: '14px', marginBottom: '15px', opacity: 0.8 }}>
                        Different optimization strategies suggested by LLMs and agents:
                      </p>
                      <CodeVariation 
                        version="GPT-4 Suggestion"
                        score={85}
                        description="Threading + PIL optimization"
                        isSelected={selectedVariation.functions === 'v1'}
                        onClick={() => setSelectedVariation({...selectedVariation, functions: 'v1'})}
                      />
                      <CodeVariation 
                        version="Claude Suggestion"
                        score={91}
                        description="NumPy vectorization + caching"
                        isSelected={selectedVariation.functions === 'v2'}
                        onClick={() => setSelectedVariation({...selectedVariation, functions: 'v2'})}
                      />
                      <CodeVariation 
                        version="Agent Synthesis"
                        score={94}
                        description="Multiprocessing + SciPy + memory pool"
                        isSelected={selectedVariation.functions === 'v3'}
                        onClick={() => setSelectedVariation({...selectedVariation, functions: 'v3'})}
                      />
                      <CodeVariation 
                        version="Hybrid Approach"
                        score={88}
                        description="GPU acceleration with fallback"
                        isSelected={selectedVariation.functions === 'v4'}
                        onClick={() => setSelectedVariation({...selectedVariation, functions: 'v4'})}
                      />
                    </div>
                  )}
                </div>

                {/* Second Example: Database Query Functions */}
                <h3 style={{ margin: '30px 0 20px 0', color: '#F39C12' }}>
                  Example 2: Database Query Optimization
                </h3>
                
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '20px'
                }}>
                  {/* Before */}
                  <div>
                    <h4 style={{ color: '#E74C3C', marginBottom: '15px' }}>❌ Original Function:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '350px',
                      border: '1px solid rgba(231, 76, 60, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`def get_user_analytics(user_id, start_date, end_date):
    """Get user analytics with multiple queries"""
    # Separate queries for each metric
    orders = db.query(
        "SELECT * FROM orders WHERE user_id = ? 
         AND date BETWEEN ? AND ?",
        user_id, start_date, end_date
    )
    
    # N+1 problem: query for each order
    for order in orders:
        items = db.query(
            "SELECT * FROM order_items WHERE order_id = ?",
            order.id
        )
        order.items = items
    
    # More separate queries
    reviews = db.query(
        "SELECT * FROM reviews WHERE user_id = ?",
        user_id
    )
    
    clicks = db.query(
        "SELECT COUNT(*) FROM clicks WHERE user_id = ?",
        user_id
    )
    
    # Process in Python (inefficient)
    total_spent = sum(o.amount for o in orders)
    avg_rating = sum(r.rating for r in reviews) / len(reviews)
    
    return {
        'orders': orders,
        'total_spent': total_spent,
        'avg_rating': avg_rating,
        'click_count': clicks[0]
    }
    
# Performance: 2.3s per user`}</code>
                    </pre>
                  </div>

                  {/* After */}
                  <div>
                    <h4 style={{ color: '#27AE60', marginBottom: '15px' }}>✅ Artemis Optimized:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '350px',
                      border: '2px solid rgba(39, 174, 96, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`def get_user_analytics(user_id, start_date, end_date):
    """Optimized with single query and caching"""
    # Check cache first
    cache_key = f"analytics:{user_id}:{start_date}:{end_date}"
    if cached := redis.get(cache_key):
        return json.loads(cached)
    
    # Single optimized query with CTEs
    result = db.query_one("""
        WITH user_orders AS (
            SELECT o.*, 
                   json_agg(oi.*) as items,
                   SUM(o.amount) OVER() as total_spent
            FROM orders o
            LEFT JOIN order_items oi ON o.id = oi.order_id
            WHERE o.user_id = $1 
              AND o.date BETWEEN $2 AND $3
            GROUP BY o.id
        ),
        user_metrics AS (
            SELECT 
                AVG(r.rating) as avg_rating,
                COUNT(DISTINCT c.id) as click_count
            FROM reviews r
            FULL OUTER JOIN clicks c ON c.user_id = r.user_id
            WHERE r.user_id = $1 OR c.user_id = $1
        )
        SELECT 
            json_agg(DISTINCT uo.*) as orders,
            COALESCE(MAX(uo.total_spent), 0) as total_spent,
            um.avg_rating,
            um.click_count
        FROM user_orders uo
        CROSS JOIN user_metrics um
        GROUP BY um.avg_rating, um.click_count
    """, user_id, start_date, end_date)
    
    # Cache for 5 minutes
    redis.setex(cache_key, 300, json.dumps(result))
    return result
    
# Performance: 0.08s per user (28x faster!)
# With cache hit: 0.002s (1150x faster!)`}</code>
                    </pre>
                  </div>
                </div>
              </div>

              {/* Repository-wide Impact */}
              <div style={{
                background: 'rgba(155, 89, 182, 0.1)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid rgba(155, 89, 182, 0.3)'
              }}>
                <h4 style={{ margin: '0 0 10px 0', color: '#9B59B6' }}>
                  🌐 Function Optimization Across Repository
                </h4>
                <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.8' }}>
                  Artemis analyzed <strong>312 functions</strong> across the codebase:
                  <br/>• 87 database functions optimized with query consolidation
                  <br/>• 45 image processing functions parallelized
                  <br/>• 62 API endpoints optimized with caching
                  <br/>• 118 utility functions vectorized or memoized
                  <br/>• Overall application performance: <strong>5.2x faster</strong>
                </p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'software2' && (
          <div>
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '16px',
              padding: '40px',
              marginBottom: '30px'
            }}>
              <h2 style={{ margin: '0 0 10px 0', fontSize: '32px', color: '#E74C3C' }}>
                Software 2.0: Model Parameter Optimization
              </h2>
              <p style={{ margin: '0 0 30px 0', fontSize: '18px', opacity: 0.8 }}>
                Artemis optimizes machine learning model parameters across your entire ML pipeline
              </p>

              {/* Example: LightGBM Optimization */}
              <div style={{
                background: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '12px',
                padding: '30px',
                marginBottom: '30px'
              }}>
                <h3 style={{ margin: '0 0 20px 0', color: '#E74C3C' }}>
                  Example: Fraud Detection Model
                </h3>
                
                {/* Side by side comparison */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '30px',
                  marginBottom: '30px'
                }}>
                  {/* Before Section */}
                  <div>
                    <h4 style={{ color: '#E74C3C', marginBottom: '15px' }}>❌ Before Optimization:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '450px',
                      border: '1px solid rgba(231, 76, 60, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`import lightgbm as lgb

# Default parameters - suboptimal performance
model = lgb.LGBMClassifier(
    `}<span style={{ background: 'rgba(231, 76, 60, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #E74C3C' }}>n_estimators=100</span>{`,
    `}<span style={{ background: 'rgba(231, 76, 60, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #E74C3C' }}>max_depth=-1</span>{`,
    `}<span style={{ background: 'rgba(231, 76, 60, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #E74C3C' }}>learning_rate=0.1</span>{`,
    `}<span style={{ background: 'rgba(231, 76, 60, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #E74C3C' }}>num_leaves=31</span>{`,
    `}<span style={{ background: 'rgba(231, 76, 60, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #E74C3C' }}>min_child_samples=20</span>{`,
    random_state=42
)

# Training
model.fit(X_train, y_train)

# Results
# Accuracy: 0.87
# Precision: 0.82
# Recall: 0.79
# F1-Score: 0.80
# Training time: 145 seconds`}</code>
                    </pre>
                  </div>

                  {/* After Section */}
                  <div>
                    <h4 style={{ color: '#27AE60', marginBottom: '15px' }}>✅ After Artemis Optimization:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '450px',
                      border: '2px solid rgba(39, 174, 96, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`import lightgbm as lgb

# Artemis-optimized parameters
model = lgb.LGBMClassifier(
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>n_estimators=250</span>{`,
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>max_depth=7</span>{`,
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>learning_rate=0.05</span>{`,
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>num_leaves=64</span>{`,
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>min_child_samples=50</span>{`,
    # New optimized parameters
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>reg_alpha=0.1</span>{`,
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>reg_lambda=0.1</span>{`,
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>colsample_bytree=0.8</span>{`,
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>subsample=0.8</span>{`,
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>scale_pos_weight=2.3</span>{`,
    random_state=42
)

# Training with early stopping
model.fit(
    X_train, y_train,
    eval_set=[(X_val, y_val)],
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>early_stopping_rounds=20</span>{`,
    verbose=False
)

# Results
# Accuracy: 0.94 (+7%)
# Precision: 0.91 (+9%) 
# Recall: 0.93 (+14%)
# F1-Score: 0.92 (+12%)
# Training time: 87s (-40%)`}</code>
                    </pre>
                  </div>
                </div>
                
                {/* Key optimizations */}
                <div style={{
                  background: 'rgba(231, 76, 60, 0.1)',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid rgba(231, 76, 60, 0.3)',
                  marginBottom: '20px'
                }}>
                  <h4 style={{ margin: '0 0 15px 0', color: '#E74C3C' }}>
                    🔍 Key Changes Made:
                  </h4>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '15px'
                  }}>
                    <div>
                      <strong>Trees & Learning:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>More trees (100→250)</li>
                        <li>Lower learning rate (0.1→0.05)</li>
                        <li>Early stopping added</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Depth & Complexity:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Limited depth (-1→7)</li>
                        <li>More leaves (31→64)</li>
                        <li>Higher min samples (20→50)</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Regularization:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>L1/L2 regularization added</li>
                        <li>Feature/row subsampling</li>
                        <li>Class weight balancing</li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Variations Section */}
                <div 
                  style={{
                    marginBottom: '20px',
                    padding: '20px',
                    background: 'rgba(155, 89, 182, 0.1)',
                    borderRadius: '8px',
                    border: '1px solid rgba(155, 89, 182, 0.3)',
                    cursor: 'pointer'
                  }}
                  onClick={() => toggleVariations('software2')}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 style={{ margin: 0, color: '#9B59B6' }}>
                      🧬 Artemis Parameter Variations (4)
                    </h4>
                    <span style={{ fontSize: '14px', opacity: 0.7 }}>
                      {expandedVariations.software2 ? '▼' : '▶'} Click to {expandedVariations.software2 ? 'hide' : 'show'}
                    </span>
                  </div>
                  
                  {expandedVariations.software2 && (
                    <div style={{ marginTop: '20px' }}>
                      <p style={{ fontSize: '14px', marginBottom: '15px', opacity: 0.8 }}>
                        Artemis explores the hyperparameter space intelligently:
                      </p>
                      <CodeVariation 
                        version="Variation 1"
                        score={88}
                        description="Conservative: fewer trees, lower learning rate"
                        isSelected={selectedVariation.software2 === 'v1'}
                        onClick={() => setSelectedVariation({...selectedVariation, software2: 'v1'})}
                      />
                      <CodeVariation 
                        version="Variation 2"
                        score={95}
                        description="Balanced: optimal depth, regularization"
                        isSelected={selectedVariation.software2 === 'v2'}
                        onClick={() => setSelectedVariation({...selectedVariation, software2: 'v2'})}
                      />
                      <CodeVariation 
                        version="Variation 3"
                        score={91}
                        description="Aggressive: more trees, higher learning rate"
                        isSelected={selectedVariation.software2 === 'v3'}
                        onClick={() => setSelectedVariation({...selectedVariation, software2: 'v3'})}
                      />
                      <CodeVariation 
                        version="Variation 4"
                        score={86}
                        description="Complex: deep trees, many leaves"
                        isSelected={selectedVariation.software2 === 'v4'}
                        onClick={() => setSelectedVariation({...selectedVariation, software2: 'v4'})}
                      />
                    </div>
                  )}
                </div>

                {/* Performance Results */}
                <div style={{
                  background: 'rgba(39, 174, 96, 0.1)',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid rgba(39, 174, 96, 0.3)'
                }}>
                  <h4 style={{ margin: '0 0 15px 0', color: '#27AE60' }}>
                    📊 Performance Improvements:
                  </h4>
                  <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '15px'
                  }}>
                    <div>
                      <strong>Accuracy Metrics:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Accuracy: 87% → 94% (+7%)</li>
                        <li>Precision: 82% → 91% (+9%)</li>
                        <li>Recall: 79% → 93% (+14%)</li>
                        <li>F1-Score: 80% → 92% (+12%)</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Efficiency Gains:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Training time: 145s → 87s (-40%)</li>
                        <li>Model size: -25%</li>
                        <li>Inference speed: +30%</li>
                        <li>Memory usage: -20%</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Business Impact:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Fraud caught: +14%</li>
                        <li>False positives: -35%</li>
                        <li>Annual savings: $2.3M</li>
                        <li>Customer satisfaction: +8%</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pipeline-wide Impact */}
              <div style={{
                background: 'rgba(155, 89, 182, 0.1)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid rgba(155, 89, 182, 0.3)'
              }}>
                <h4 style={{ margin: '0 0 10px 0', color: '#9B59B6' }}>
                  🌐 ML Pipeline Optimization
                </h4>
                <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.8' }}>
                  Artemis optimized the entire ML pipeline:
                  <br/>• Feature engineering: Added 12 new fraud indicators
                  <br/>• Model ensemble: Optimized 3 models with different strengths
                  <br/>• Threshold tuning: Dynamic thresholds based on risk levels
                  <br/>• Total fraud detection improvement: <strong>$2.3M saved annually</strong>
                </p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'software3' && (
          <div>
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '16px',
              padding: '40px',
              marginBottom: '30px'
            }}>
              <h2 style={{ margin: '0 0 10px 0', fontSize: '32px', color: '#27AE60' }}>
                Software 3.0: Agentic Prompt Optimization
              </h2>
              <p style={{ margin: '0 0 30px 0', fontSize: '18px', opacity: 0.8 }}>
                Artemis optimizes prompts for AI agents across your entire system
              </p>

              {/* Example: Multi-Agent System */}
              <div style={{
                background: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '12px',
                padding: '30px',
                marginBottom: '30px'
              }}>
                <h3 style={{ margin: '0 0 20px 0', color: '#27AE60' }}>
                  Example: E-commerce Multi-Agent System
                </h3>
                
                {/* Side by side comparison */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '30px',
                  marginBottom: '30px'
                }}>
                  {/* Before Section */}
                  <div>
                    <h4 style={{ color: '#E74C3C', marginBottom: '15px' }}>❌ Before Optimization:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '500px',
                      border: '1px solid rgba(231, 76, 60, 0.3)'
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`# 4 Independent prompts - not optimized together
product_search_prompt = `}<span style={{ background: 'rgba(231, 76, 60, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #E74C3C' }}>"""Find products based on user query"""</span>{`

recommendation_prompt = `}<span style={{ background: 'rgba(231, 76, 60, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #E74C3C' }}>"""Suggest similar products"""</span>{`

cart_optimization_prompt = `}<span style={{ background: 'rgba(231, 76, 60, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #E74C3C' }}>"""Help user with cart"""</span>{`

support_prompt = `}<span style={{ background: 'rgba(231, 76, 60, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #E74C3C' }}>"""Answer customer questions"""</span>{`

# Each agent works in isolation
search_results = llm(product_search_prompt + query)
recommendations = llm(recommendation_prompt + search_results)
cart_help = llm(cart_optimization_prompt + cart_state)
support = llm(support_prompt + customer_question)

# Results:
# - Inconsistent responses between agents
# - No shared context or memory
# - Duplicate work (each agent re-analyzes user)
# - Poor cross-selling (22% conversion)
# - High token usage (4x redundancy)`}</code>
                    </pre>
                  </div>

                  {/* After Section */}
                  <div>
                    <h4 style={{ color: '#27AE60', marginBottom: '15px' }}>✅ After Artemis Optimization:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '500px',
                      border: '2px solid rgba(39, 174, 96, 0.3)'
                    }}>
                      <code style={{ color: '#f8f8f2' }}>{`# Artemis-optimized: 4 prompts working together
ecommerce_agent_system = {
    # Shared context passed between all agents
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>"shared_context"</span>{`: {
        "user_profile": {},
        "session_intent": "",
        "interaction_history": [],
        "recommendations": []
    },
    
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>"product_search_agent"</span>{`: """
    You are the product discovery specialist.
    Context from other agents: {shared_context}
    Your role:
    1. Understand search intent
    2. Apply smart filters based on user history
    3. Rank by: relevance + preferences + margin
    4. Pass findings to recommendation agent
    """,
    
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>"recommendation_agent"</span>{`: """
    You are the personalization expert.
    Search results: {search_agent.products}
    Your role:
    1. Analyze search results + user behavior
    2. Find complementary products (cross-sell)
    3. Suggest upgrades (upsell) when appropriate
    4. Create bundles for better value
    """,
    
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>"cart_optimization_agent"</span>{`: """
    You are the conversion optimizer.
    Recommendations: {recommendation_agent.output}
    Your role:
    1. Optimize cart for conversion
    2. Apply dynamic discounts based on cart value
    3. Suggest quantity breaks for savings
    4. Remove friction (free shipping thresholds)
    """,
    
    `}<span style={{ background: 'rgba(39, 174, 96, 0.3)', padding: '2px 4px', borderRadius: '4px', border: '1px solid #27AE60' }}>"support_agent"</span>{`: """
    You are the trust builder and problem solver.
    Full context: {shared_context}
    Your role:
    1. Proactively address concerns
    2. Provide social proof (reviews, testimonials)
    3. Explain policies (returns, warranty)
    4. Handle objections from other agents' insights
    """
}

# Orchestrated execution - agents work together
shared_context = analyze_user(session_data)
results = orchestrate_agents(query, shared_context)

# Results:
# - 58% increase in conversion rate
# - 3.2x higher average order value
# - 87% customer satisfaction
# - 65% reduction in cart abandonment`}</code>
                    </pre>
                  </div>
                </div>

                {/* Key optimizations */}
                <div style={{
                  background: 'rgba(39, 174, 96, 0.1)',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid rgba(39, 174, 96, 0.3)',
                  marginBottom: '20px'
                }}>
                  <h4 style={{ margin: '0 0 15px 0', color: '#27AE60' }}>
                    🔍 Key Optimizations Applied:
                  </h4>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '15px'
                  }}>
                    <div>
                      <strong>Unified System:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Shared context between agents</li>
                        <li>Sequential information flow</li>
                        <li>Consistent decision making</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Specialized Roles:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Each agent has clear purpose</li>
                        <li>No duplicate analysis</li>
                        <li>Complementary skills</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Intelligence:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Context-aware responses</li>
                        <li>Learn from interactions</li>
                        <li>Proactive assistance</li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Variations Section */}
                <div 
                  style={{
                    marginBottom: '20px',
                    padding: '20px',
                    background: 'rgba(155, 89, 182, 0.1)',
                    borderRadius: '8px',
                    border: '1px solid rgba(155, 89, 182, 0.3)',
                    cursor: 'pointer'
                  }}
                  onClick={() => toggleVariations('software3')}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 style={{ margin: 0, color: '#9B59B6' }}>
                      🧬 Artemis Prompt Variations (4)
                    </h4>
                    <span style={{ fontSize: '14px', opacity: 0.7 }}>
                      {expandedVariations.software3 ? '▼' : '▶'} Click to {expandedVariations.software3 ? 'hide' : 'show'}
                    </span>
                  </div>
                  
                  {expandedVariations.software3 && (
                    <div style={{ marginTop: '20px' }}>
                      <p style={{ fontSize: '14px', marginBottom: '15px', opacity: 0.8 }}>
                        Artemis tests different combinations of all 4 prompts together:
                      </p>
                      <CodeVariation 
                        version="Combination 1"
                        score={72}
                        description="Independent prompts with basic context"
                        isSelected={selectedVariation.software3 === 'v1'}
                        onClick={() => setSelectedVariation({...selectedVariation, software3: 'v1'})}
                      />
                      <CodeVariation 
                        version="Combination 2"
                        score={81}
                        description="Shared memory + sequential flow"
                        isSelected={selectedVariation.software3 === 'v2'}
                        onClick={() => setSelectedVariation({...selectedVariation, software3: 'v2'})}
                      />
                      <CodeVariation 
                        version="Combination 3"
                        score={89}
                        description="Orchestrated agents + shared context"
                        isSelected={selectedVariation.software3 === 'v3'}
                        onClick={() => setSelectedVariation({...selectedVariation, software3: 'v3'})}
                      />
                      <CodeVariation 
                        version="Combination 4"
                        score={96}
                        description="Specialized roles + unified objective"
                        isSelected={selectedVariation.software3 === 'v4'}
                        onClick={() => setSelectedVariation({...selectedVariation, software3: 'v4'})}
                      />
                    </div>
                  )}
                </div>

                {/* Performance Results */}
                <div style={{
                  background: 'rgba(39, 174, 96, 0.1)',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid rgba(39, 174, 96, 0.3)'
                }}>
                  <h4 style={{ margin: '0 0 15px 0', color: '#27AE60' }}>
                    📊 Performance Improvements:
                  </h4>
                  <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '15px'
                  }}>
                    <div>
                      <strong>Conversion Metrics:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Conversion rate: +58%</li>
                        <li>Average order value: 3.2x</li>
                        <li>Cart abandonment: -65%</li>
                        <li>Cross-sell success: +180%</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Efficiency Gains:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Token usage: -75%</li>
                        <li>Response time: -67%</li>
                        <li>API calls: -60%</li>
                        <li>Cost per interaction: -72%</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Customer Experience:</strong>
                      <ul style={{ margin: '5px 0 0 0', paddingLeft: '20px', fontSize: '14px' }}>
                        <li>Satisfaction: 65% → 92%</li>
                        <li>Resolution rate: 55% → 94%</li>
                        <li>Repeat purchases: +45%</li>
                        <li>Support escalations: -40%</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* System-wide Impact */}
              <div style={{
                background: 'rgba(155, 89, 182, 0.1)',
                padding: '20px',
                borderRadius: '12px',
                border: '1px solid rgba(155, 89, 182, 0.3)'
              }}>
                <h4 style={{ margin: '0 0 10px 0', color: '#9B59B6' }}>
                  🌐 Agentic System Optimization
                </h4>
                <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.8' }}>
                  Artemis optimized the entire agentic system:
                  <br/>• 8 specialized agents working in harmony
                  <br/>• Dynamic prompt adjustment based on performance
                  <br/>• Cross-agent learning and improvement
                  <br/>• Total operational cost reduction: <strong>65% with 2x better outcomes</strong>
                </p>
              </div>
            </div>
          </div>
        )}

        {/* SQL Migration Tab */}
        {activeTab === 'sqlMigration' && (
          <div>
            <div style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '16px',
              padding: '40px',
              marginBottom: '30px'
            }}>
              <h2 style={{ margin: '0 0 10px 0', fontSize: '32px', color: '#9B59B6' }}>
                SQL to Snowflake Migration
              </h2>
              <p style={{ margin: '0 0 30px 0', fontSize: '18px', opacity: 0.8 }}>
                Artemis optimizes your SQL queries for modern cloud data warehouses
              </p>
              
              <div style={{
                background: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '12px',
                padding: '30px',
                overflow: 'hidden'
              }}>
                <h3 style={{ margin: '0 0 20px 0', color: '#9B59B6' }}>
                  Analytics Dashboard Query Optimization
                </h3>
                
                {/* Side by side comparison */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: '30px',
                  marginBottom: '30px'
                }}>
                  {/* Traditional SQL */}
                  <div>
                    <h4 style={{ color: '#E74C3C', marginBottom: '15px' }}>❌ Traditional SQL Server:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '500px',
                      border: '1px solid rgba(231, 76, 60, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>
                        <div>{`-- Daily sales aggregation query
WITH daily_sales AS (
  SELECT 
    DATE(order_date) as sale_date,
    product_id,
    SUM(quantity * price) as revenue
  FROM orders o
  JOIN order_items oi ON o.order_id = oi.order_id
  WHERE order_date >= DATEADD(month, -6, GETDATE())
  GROUP BY DATE(order_date), product_id
),
product_ranks AS (
  SELECT 
    sale_date,
    product_id,
    revenue,`}</div>
                        <div>    <span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>ROW_NUMBER() OVER (
      PARTITION BY sale_date 
      ORDER BY revenue DESC
    ) as rank</span></div>
                        <div>{`  FROM daily_sales
)
SELECT 
  pr.*,
  p.product_name,
  p.category,`}</div>
                        <div>  <span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>-- Subquery for running totals
  (SELECT SUM(revenue) 
   FROM daily_sales ds2 
   WHERE ds2.product_id = pr.product_id 
   AND ds2.sale_date {'<'}= pr.sale_date) as running_total</span></div>
                        <div>{`FROM product_ranks pr
JOIN products p ON pr.product_id = p.product_id
WHERE rank <= 10
ORDER BY sale_date DESC, rank;

-- Performance issues:`}</div>
                        <div>-- • <span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>No columnar storage</span></div>
                        <div>-- • <span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>Row-by-row processing</span></div>
                        <div>-- • <span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>Expensive subqueries</span></div>
                        <div>-- • <span style={{ background: 'rgba(231, 76, 60, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #E74C3C', fontWeight: 'bold' }}>No automatic scaling</span></div>
                        <div>-- • Execution time: 45 seconds</div>
                      </code>
                    </pre>
                  </div>

                  {/* Snowflake Optimized */}
                  <div>
                    <h4 style={{ color: '#27AE60', marginBottom: '15px' }}>✅ Snowflake Optimized:</h4>
                    <pre style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                      padding: '20px',
                      borderRadius: '8px',
                      fontSize: '12px',
                      overflow: 'auto',
                      height: '500px',
                      border: '2px solid rgba(39, 174, 96, 0.3)',
                      minWidth: 0
                    }}>
                      <code style={{ color: '#f8f8f2' }}>
                        <div>{`-- Artemis-optimized Snowflake query
WITH daily_sales AS (
  SELECT 
    order_date::DATE as sale_date,
    product_id,
    SUM(quantity * price) as revenue
  FROM orders o
  JOIN order_items oi `}<span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>USING (order_id)</span>{`
  WHERE order_date >= DATEADD('month', -6, CURRENT_DATE())
  GROUP BY 1, 2
)
SELECT 
  sale_date,
  product_id,
  product_name,
  category,
  revenue,`}</div>
                        <div>  <span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>RANK() OVER (
    PARTITION BY sale_date 
    ORDER BY revenue DESC
  ) as rank</span>,</div>
                        <div>  <span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>-- Window function for running totals
  SUM(revenue) OVER (
    PARTITION BY product_id 
    ORDER BY sale_date
    ROWS UNBOUNDED PRECEDING
  ) as running_total</span></div>
                        <div>{`FROM daily_sales
JOIN products p USING (product_id)`}</div>
                        <div><span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>QUALIFY rank {'<'}= 10</span></div>
                        <div>{`ORDER BY sale_date DESC, rank;

-- Snowflake advantages:`}</div>
                        <div>-- • <span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>Columnar storage</span></div>
                        <div>-- • <span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>Micro-partitioning</span></div>
                        <div>-- • <span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>Result caching</span></div>
                        <div>-- • <span style={{ background: 'rgba(39, 174, 96, 0.4)', padding: '2px 6px', borderRadius: '4px', border: '1px solid #27AE60', fontWeight: 'bold' }}>Auto-scaling compute</span></div>
                        <div>-- • Execution time: 2.3 seconds (20x faster!)</div>
                      </code>
                    </pre>
                  </div>
                </div>

                {/* Key Optimizations */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '20px',
                  marginTop: '30px',
                  fontSize: '14px'
                }}>
                  <div style={{
                    background: 'rgba(52, 152, 219, 0.1)',
                    padding: '15px',
                    borderRadius: '8px',
                    border: '1px solid rgba(52, 152, 219, 0.3)'
                  }}>
                    <strong style={{ color: '#3498DB' }}>Query Structure:</strong>
                    <div>• USING clause for cleaner joins</div>
                    <div>• QUALIFY for post-window filtering</div>
                    <div>• Window functions vs subqueries</div>
                  </div>
                  <div style={{
                    background: 'rgba(39, 174, 96, 0.1)',
                    padding: '15px',
                    borderRadius: '8px',
                    border: '1px solid rgba(39, 174, 96, 0.3)'
                  }}>
                    <strong style={{ color: '#27AE60' }}>Performance:</strong>
                    <div>• 20x query speedup</div>
                    <div>• Automatic query optimization</div>
                    <div>• Zero maintenance overhead</div>
                  </div>
                  <div style={{
                    background: 'rgba(155, 89, 182, 0.1)',
                    padding: '15px',
                    borderRadius: '8px',
                    border: '1px solid rgba(155, 89, 182, 0.3)'
                  }}>
                    <strong style={{ color: '#9B59B6' }}>Cost Optimization:</strong>
                    <div>• Pay per query execution</div>
                    <div>• Auto-suspend warehouses</div>
                    <div>• 70% cost reduction</div>
                  </div>
                </div>

                {/* Migration Impact */}
                <div style={{
                  background: 'rgba(155, 89, 182, 0.1)',
                  padding: '20px',
                  borderRadius: '12px',
                  marginTop: '20px',
                  border: '1px solid rgba(155, 89, 182, 0.3)'
                }}>
                  <h4 style={{ margin: '0 0 10px 0', color: '#9B59B6' }}>
                    🚀 Migration Impact Analysis
                  </h4>
                  <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.8' }}>
                    Artemis analyzed <strong>312 SQL queries</strong> and optimized them for Snowflake:
                    <br/>• 89 subqueries → window functions
                    <br/>• 124 temp tables → CTEs with materialization hints
                    <br/>• 47 stored procedures → Snowflake UDFs
                    <br/>• 52 indexes removed (not needed in Snowflake)
                    <br/>• Overall performance: <strong>15x faster</strong> at <strong>70% lower cost</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Footer Note */}
        <div style={{
          marginTop: '40px',
          padding: '30px',
          background: 'linear-gradient(135deg, rgba(155, 89, 182, 0.1), rgba(142, 68, 173, 0.1))',
          borderRadius: '16px',
          border: '1px solid rgba(155, 89, 182, 0.3)',
          textAlign: 'center'
        }}>
          <h3 style={{ margin: '0 0 15px 0', color: '#9B59B6' }}>
            🚀 The Artemis Advantage
          </h3>
          <p style={{ margin: 0, fontSize: '16px', lineHeight: '1.8' }}>
            Unlike traditional optimization tools that work in isolation, Artemis analyzes your entire system
            holistically. It generates multiple variations, tests them in combination, and finds the global
            optimum that delivers the best performance across all metrics.
          </p>
        </div>

        {/* End-to-End Process Diagram */}
        {activeTab === 'overview' && (
          <div style={{
            marginTop: '40px',
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '16px',
            padding: '40px',
            border: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <h2 style={{ margin: '0 0 30px 0', fontSize: '28px', textAlign: 'center' }}>
              How Artemis Works: Your Optimization Journey
            </h2>

            <div style={{ position: 'relative', padding: '20px 0' }}>
              {/* User Journey Steps */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(6, 1fr)',
                gap: '20px',
                marginBottom: '40px'
              }}>
                {/* Step 1: Upload */}
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #3498DB, #2980B9)',
                    margin: '0 auto 10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'white'
                  }}>
                    1
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>Upload Code</div>
                  <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '5px' }}>
                    Push to repo
                  </div>
                </div>

                {/* Step 2: Request */}
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #E74C3C, #C0392B)',
                    margin: '0 auto 10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'white'
                  }}>
                    2
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>Request</div>
                  <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '5px' }}>
                    "Better performance"
                  </div>
                </div>

                {/* Step 3: Analyze */}
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #F39C12, #E67E22)',
                    margin: '0 auto 10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'white'
                  }}>
                    3
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>Scan Repo</div>
                  <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '5px' }}>
                    Find bottlenecks
                  </div>
                </div>

                {/* Step 4: Generate */}
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #27AE60, #229954)',
                    margin: '0 auto 10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'white'
                  }}>
                    4
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>Generate</div>
                  <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '5px' }}>
                    Multiple solutions
                  </div>
                </div>

                {/* Step 5: Evolve */}
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #9B59B6, #8E44AD)',
                    margin: '0 auto 10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'white'
                  }}>
                    5
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>Evolve</div>
                  <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '5px' }}>
                    Best combination
                  </div>
                </div>

                {/* Step 6: PR */}
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #4ECDC4, #44A08D)',
                    margin: '0 auto 10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'white'
                  }}>
                    6
                  </div>
                  <div style={{ fontSize: '14px', fontWeight: '600' }}>Pull Request</div>
                  <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '5px' }}>
                    Review & merge
                  </div>
                </div>
              </div>

              {/* Detailed Flow Diagram */}
              <div style={{
                background: 'rgba(0, 0, 0, 0.2)',
                borderRadius: '12px',
                padding: '30px',
                marginTop: '20px'
              }}>
                {/* Row 1: User Action */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '200px 1fr',
                  gap: '30px',
                  marginBottom: '25px',
                  alignItems: 'center'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #3498DB, #2980B9)',
                    padding: '15px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    fontWeight: '600'
                  }}>
                    👤 You
                  </div>
                  <div style={{
                    display: 'flex',
                    gap: '15px',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      background: 'rgba(52, 152, 219, 0.2)',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      border: '1px solid rgba(52, 152, 219, 0.4)'
                    }}>
                      "I want better performance"
                    </div>
                    <span style={{ color: '#3498DB' }}>→</span>
                    <div style={{
                      background: 'rgba(52, 152, 219, 0.2)',
                      padding: '12px 20px',
                      borderRadius: '8px',
                      border: '1px solid rgba(52, 152, 219, 0.4)'
                    }}>
                      Artemis analyzes entire repo
                    </div>
                  </div>
                </div>

                {/* Row 2: Artemis Finds Issues */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '200px 1fr',
                  gap: '30px',
                  marginBottom: '25px',
                  alignItems: 'center'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #F39C12, #E67E22)',
                    padding: '15px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    fontWeight: '600'
                  }}>
                    🔍 Artemis Scans
                  </div>
                  <div style={{
                    display: 'flex',
                    gap: '10px',
                    flexWrap: 'wrap'
                  }}>
                    {[
                      { file: 'api.py', issue: 'N+1 queries' },
                      { file: 'utils.py', issue: 'Nested loops' },
                      { file: 'model.py', issue: 'Bad params' },
                      { file: 'cache.py', issue: 'No caching' }
                    ].map((item, idx) => (
                      <div key={idx} style={{
                        background: 'rgba(243, 156, 18, 0.2)',
                        padding: '8px 15px',
                        borderRadius: '6px',
                        border: '1px solid rgba(243, 156, 18, 0.4)',
                        fontSize: '13px'
                      }}>
                        <strong>{item.file}:</strong> {item.issue}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Row 3: Generate Variations */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '200px 1fr',
                  gap: '30px',
                  marginBottom: '25px',
                  alignItems: 'center'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #27AE60, #229954)',
                    padding: '15px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    fontWeight: '600'
                  }}>
                    🧬 Generate Variations
                  </div>
                  <div>
                    <div style={{ fontSize: '13px', marginBottom: '10px', opacity: 0.8 }}>
                      For each issue, multiple solutions from LLMs & agents:
                    </div>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(4, 1fr)',
                      gap: '10px'
                    }}>
                      {['api.py', 'utils.py', 'model.py', 'cache.py'].map((file, idx) => (
                        <div key={idx} style={{
                          background: 'rgba(39, 174, 96, 0.1)',
                          padding: '10px',
                          borderRadius: '6px',
                          border: '1px solid rgba(39, 174, 96, 0.3)',
                          fontSize: '12px',
                          textAlign: 'center'
                        }}>
                          <div style={{ fontWeight: '600', marginBottom: '5px' }}>{file}</div>
                          <div style={{ opacity: 0.7 }}>3-5 variations</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Row 4: Genetic Algorithm */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '200px 1fr',
                  gap: '30px',
                  marginBottom: '25px',
                  alignItems: 'center'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #9B59B6, #8E44AD)',
                    padding: '15px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    fontWeight: '600'
                  }}>
                    🧪 Genetic Algorithm
                  </div>
                  <div>
                    <div style={{ fontSize: '13px', marginBottom: '10px', opacity: 0.8 }}>
                      Tests combinations to find the best overall solution:
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <div style={{
                        background: 'rgba(155, 89, 182, 0.2)',
                        padding: '10px 15px',
                        borderRadius: '6px',
                        border: '1px solid rgba(155, 89, 182, 0.4)',
                        fontSize: '12px'
                      }}>
                        api.v2 + utils.v3 + model.v1 + cache.v4 = <strong>Score: 94</strong>
                      </div>
                      <span style={{ color: '#9B59B6', fontSize: '20px' }}>✓</span>
                    </div>
                  </div>
                </div>

                {/* Row 5: Pull Request */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '200px 1fr',
                  gap: '30px',
                  alignItems: 'center'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #4ECDC4, #44A08D)',
                    padding: '15px',
                    borderRadius: '8px',
                    textAlign: 'center',
                    fontWeight: '600'
                  }}>
                    🔀 Pull Request
                  </div>
                  <div style={{
                    background: 'rgba(78, 205, 196, 0.2)',
                    padding: '15px 20px',
                    borderRadius: '8px',
                    border: '1px solid rgba(78, 205, 196, 0.4)'
                  }}>
                    <div style={{ fontWeight: '600', marginBottom: '5px' }}>
                      PR: "Performance optimization across codebase"
                    </div>
                    <div style={{ fontSize: '13px', opacity: 0.8 }}>
                      ✓ 4 files changed • +127 -89 lines • 5.2x performance improvement
                    </div>
                  </div>
                </div>
              </div>

              {/* Key Benefits */}
              <div style={{
                marginTop: '30px',
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '20px'
              }}>
                <div style={{
                  background: 'rgba(52, 152, 219, 0.1)',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid rgba(52, 152, 219, 0.3)',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '24px', marginBottom: '10px' }}>🎯</div>
                  <h4 style={{ margin: '0 0 5px 0', color: '#3498DB' }}>Holistic</h4>
                  <p style={{ margin: 0, fontSize: '13px', opacity: 0.8 }}>
                    Optimizes entire codebase, not just individual files
                  </p>
                </div>
                <div style={{
                  background: 'rgba(155, 89, 182, 0.1)',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid rgba(155, 89, 182, 0.3)',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '24px', marginBottom: '10px' }}>🧬</div>
                  <h4 style={{ margin: '0 0 5px 0', color: '#9B59B6' }}>Intelligent</h4>
                  <p style={{ margin: 0, fontSize: '13px', opacity: 0.8 }}>
                    Finds best combination using evolutionary algorithms
                  </p>
                </div>
                <div style={{
                  background: 'rgba(39, 174, 96, 0.1)',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid rgba(39, 174, 96, 0.3)',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '24px', marginBottom: '10px' }}>✅</div>
                  <h4 style={{ margin: '0 0 5px 0', color: '#27AE60' }}>Validated</h4>
                  <p style={{ margin: 0, fontSize: '13px', opacity: 0.8 }}>
                    Each change is tested and scored before suggestion
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ArtemisEvolution;